import { FilterObject, SelectorFilter } from '@store/memberList';
import { LMS_SOURCE, LMS_USER_TOGGLE } from '@config/constant';

export const getFilter = (
	filterObject: FilterObject
): {
	selectorData: SelectorFilter;
} => {
	const { startDate, endDate } = filterObject.dateOfVisit;
	const visitStatus = filterObject.visitStatus.visitStatus;
	const secondaryData = filterObject.checkSecondary;
	const customData = filterObject.customSelect.customData.map((item) => item.value);
	const { toggleData } = filterObject.customToggle;
	const { kycStatus } = filterObject.kycStatus;
	const sourceList = filterObject.singleDropDown.dropDownData;
	const { value: parentMemberID } = filterObject.largeContractor;
	const ftqVisitStatus = filterObject.ftqVisitStatus.ftqVisitStatus;
	const mdiCode = filterObject.mdicodeDropdown.dropDownData;
	const hasLmsToggle = filterObject.customToggle.data.some((item) => item.value === LMS_USER_TOGGLE);
	const selector: SelectorFilter = {};

	if (hasLmsToggle) {
		selector.source_c = toggleData.includes(LMS_USER_TOGGLE) ? { $eq: 'LMS' } : { $ne: 'LMS' };
	}

	if (startDate && endDate) {
		selector.createddate = { $gte: startDate.toISOString(), $lte: endDate.toISOString() };
	}
	secondaryData.forEach((data, index) => {
		if (data.secondaryData.length > 0) {
			let key = '';
			switch (index) {
				case 0:
					key = 'contractorclass';
					break;
				case 1:
					key = 'contractorconsumption';
					break;
			}
			selector[key] = { $in: data.secondaryData };
		}
	});

	if (customData.length > 0) {
		selector.clubname = { $in: customData };
	}
	if (kycStatus.length > 0) {
		selector.kyc_id_proof_verification = { $eq: kycStatus === 'Verified' ? 'Verified' : 'Not-Verified' };
	}

	if (sourceList.length > 0) {
		selector.source = { $eq: sourceList };
	} else if (
		filterObject.singleDropDown.flagged &&
		filterObject.singleDropDown.data.some((item) => item.value === LMS_SOURCE)
	) {
		selector.source = { $ne: LMS_SOURCE };
	}
	toggleData.forEach((item) => {
		if (item === 'OB') {
			selector.is_a_ob = { $eq: true };
		}
		if (item === 'ZBC') {
			selector.is_zbc = { $eq: true };
		}
		if (item === 'Degrowing') {
			selector.is_de_growing = { $eq: true };
		}
		if (item === 'Adopted') {
			selector.is_adopted_by = { $eq: true };
		}
		if (item === 'Disengaged') {
			selector.is_disengaged_contractor = { $eq: true };
		}
		if (item === 'Sub Contractor') {
			selector.parent_member_id_c = {
				$exists: true,
				$ne: null,
				...(parentMemberID && { $eq: parentMemberID }),
			};
		}
		if (item === 'SSM' || item === LMS_USER_TOGGLE) {
			selector.source_c = { $eq: 'LMS' };
		}
	});
	if (filterObject.rigidGluePotential?.enabled) {
		selector.glue_consumption_per_month = { $gte: 50 };
	}
	if (visitStatus.length > 0) {
		selector.visitstatus = { $eq: visitStatus === 'Visited' ? 'Site Visited' : 'Site Not Visited' };
	}
	if (ftqVisitStatus.length > 0) {
		selector.current_quarter_visitstatus = { $eq: ftqVisitStatus === 'Visited-FTQ' };
	}

	if (mdiCode.length > 0) {
		selector.mdicode = { $eq: mdiCode };
	}
	return { selectorData: selector };
};
